const bigHeaderHeight = 143;
const smallHeaderHeight = 78;
const mobileHeight = 59;

// initial state
// shape: [{ id, quantity }]
const state = {
    showMobileMenu: false,
    megaMenuState: {
        onTopMenu: false,
        onMegaMenu: false
    },
    megaMenuPage: -1,
    mobileHeight,
    height: bigHeaderHeight,
    scrollY: 0,
    isScrolled: false
};

// getters
const getters = {
    showMegaMenu(state) {
        return state.megaMenuState.onTopMenu || state.megaMenuState.onMegaMenu;
    }

};

// actions
const actions = {
    headerHeightChange({ commit, state }, payload) {
        commit('setScrollY', payload);
        if (state.isScrolled) {
            commit('setSmallHeader', state);
        } else {
            commit('setLargeHeader', state);
        }
    },
    changeTopMenuDisplayMegaMenu({ commit }) {
        commit('topMenuDisplayMegaMenu');
    },
    changeTopMenuHideMegaMenu({ commit }) {
        commit('topMenuHideMegaMenu');
    },
    changeDisplayMegaMenu({ commit }) {
        commit('displayMegaMenu');
    },
    changeHideMegaMenu({ commit }) {
        commit('hideMegaMenu');
    }
};

// mutations
const mutations = {
    toggleMobileMenu(state) {
        state.showMobileMenu = !state.showMobileMenu;
    },
    displayMegaMenu(state) {
        state.megaMenuState.onMegaMenu = true;
    },
    hideMegaMenu(state) {
        state.megaMenuState.onMegaMenu = false;
    },
    topMenuDisplayMegaMenu(state) {
        state.megaMenuState.onTopMenu = true;
    },
    topMenuHideMegaMenu(state) {
        state.megaMenuState.onTopMenu = false;
    },
    setMegaMenuPage(state, val) {
        state.megaMenuPage = val;
    },
    setHeight(state, val) {
        state.height = val;
    },
    setLargeHeader(state) {
        state.height = bigHeaderHeight;
    },
    setSmallHeader(state) {
        state.height = smallHeaderHeight;
    },
    setScrollY(state, val) {
        state.scrollY = val;
        if (val !== 0) {
            state.isScrolled = true;
        } else {
            state.isScrolled = false;
        }
    },
    setIsScrolled(state, val) {
        state.isScrolled = val;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
